import { ReactNode } from 'react';

import { StatCard } from '@/components/ui/StatCard';

export interface MetricCard {
  title: string;
  value: number | string;
  icon?: ReactNode;
  subtitle?: string;
}

interface MetricsSectionProps {
  title: string;
  cards: MetricCard[];
  loading: boolean;
}

export function MetricsSection({ title, cards, loading }: MetricsSectionProps) {
  return (
    <section className="space-y-3">
      <h2 className="text-sm font-semibold text-[var(--color-text-secondary)]">{title}</h2>
      <div className="grid grid-cols-2 gap-3 lg:grid-cols-4">
        {cards.map((card) => (
          <StatCard
            key={card.title}
            title={card.title}
            value={card.value}
            icon={card.icon}
            subtitle={card.subtitle}
            loading={loading}
          />
        ))}
      </div>
    </section>
  );
}

export default MetricsSection;
